import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTreeModule } from '@angular/material/tree';
import { MatDialogModule } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { GeneraldocumentAddComponent } from '../generaldocument-add/generaldocument-add.component';
import { DocumentService } from 'src/app/_services/document.service';
import { User } from 'src/app/_model/user';
import { File } from 'src/app/_model/File';
import { GeneraldocumentDeleteComponent } from '../generaldocument-delete/generaldocument-delete.component';
import { environment } from '../../../environments/environment';
import { NestedTreeControl } from '@angular/cdk/tree';
import { GeneraldocumentUpdateComponent } from '../generaldocument-update/generaldocument-update.component';

interface FileNode {
  id: number;
  fileName: string;
  fileDescription: string;
  storageDocuments?: File[];
  filePath: string;
  orderSeq?: number;
  type: 'file' | 'folder';
  url: string;
  children?: FileNode[];
  parent: FileNode | null;
}

@Component({
    selector: 'app-generaldocument-list',
    templateUrl: './generaldocument-list.component.html',
    styleUrls: ['./generaldocument-list.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        MatPaginatorModule,
        MatTreeModule,
        MatDialogModule
    ]
})
export class GeneraldocumentListComponent implements OnInit {

  treeControl = new NestedTreeControl<FileNode>(node => node.children);
  currentUser: User;

  dataSource = new MatTreeNestedDataSource<FileNode>();

  originalData: FileNode[] = [];

  filterText = '';
  fileUploadRootPath: string;

  constructor(private documentService: DocumentService,
    private toastr: ToastrService,
    private authService: AuthenticationService,
    public dialog: MatDialog) {
    this.fileUploadRootPath = environment.fileUploadPath;
  }

  hasChild = (_: number, node: FileNode) => !!node.children && node.children.length > 0;

  ngOnInit() {
    this.loadFile();
    this.authService.currentUser.subscribe(value => {
      this.currentUser = value;
    });
  }

  getLevel = (node: FileNode) => {
    return this._getNodeLevel(this.dataSource.data, node, 0);
  }

  private _getNodeLevel(tree: FileNode[], target: FileNode, level: number): number {
    for (const node of tree) {
      if (node === target) {
        return level;
      } else if (node.children && node.children.length > 0) {
        const childLevel = this._getNodeLevel(node.children, target, level + 1);
        if (childLevel !== -1) return childLevel;
      }
    }
    return -1;
  }

  filterTree() {
    const searchText = this.filterText.toLowerCase();
    if (!searchText) {
      this.dataSource.data = this.originalData;
      // collapseAll'ı bir sonraki işleme bırak
      setTimeout(() => {
        this.treeControl.collapseAll();
      }, 0);
    } else {
      this.dataSource.data = this.filterData(this.originalData, searchText);
    }
    this.expandAll(this.dataSource.data);
  }

  expandAll(data: FileNode[]) {
    for (const node of data) {
      this.treeControl.expand(node);
      if (node.children && node.children.length > 0) {
        this.expandAll(node.children);
      }
    }
  }

  private filterData(data: FileNode[], searchText: string): FileNode[] {
    const normalizedSearch = searchText.toLowerCase().trim();

    return data
      .map(node => {
        // Alt klasörleri filtrele
        if (node.children) {
          const filteredChildren = this.filterData(node.children, normalizedSearch);
          if (filteredChildren.length) {
            return { ...node, children: filteredChildren };
          }
        }

        // FOLDER: sadece adı üzerinden arama
        if (node.type === 'folder') {
          if (node.fileName.toLowerCase().includes(normalizedSearch)) {
            return { ...node };
          }
        }

        // FILE: birleşik metin üzerinden arama
        if (node.type === 'file') {
          const combinedText = [
            node.fileName,
            node.fileDescription,
            ...(`${node.fileName} ${node.fileDescription}` || [])
          ]
            .join(' ')
            .toLowerCase();

          if (combinedText.includes(normalizedSearch)) {
            return { ...node };
          }
        }

        return null;
      })
      .filter(node => node !== null) as FileNode[];
  }


  loadFile() {
    this.documentService.getFile().subscribe(result => {
      if (result.success) {
        const data = this.assignParents(result.responseData.items);
        this.dataSource.data = data;
        this.originalData = data;
        console.log('Dosyalar yüklendi:', this.dataSource.data);
      }
      else {
        this.toastr.error('Hata');
      }
    });
  }

  private assignParents(nodes: FileNode[], parent: FileNode | null = null): FileNode[] {
    return nodes.map(node => {
      // Parent referansını ata
      node.parent = parent;

      // Alt elemanlar varsa onlara da recursive olarak parent ata
      if (node.children && node.children.length > 0) {
        node.children = this.assignParents(node.children, node);
      }

      return node;
    });
  }

  downloadFile(node: FileNode) {
    if (!node.url) return;
    const link = document.createElement('a');
    link.href = node.url;
    link.download = this.fileUploadRootPath + "/" + node.filePath; // alternatif olarak başka ad da verilebilir
    link.click();
  }

  deleteDocument(node: FileNode): void {
    const dialogRef = this.dialog.open(GeneraldocumentDeleteComponent, {
      width: '400px',
       data: {
            id: node.id,
            fileName: node.fileName,
            type: node.type,
            fileDescription: node.type === 'file' ? node.fileDescription : null
        }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Modal kapandıktan sonra listeyi yenile
        this.loadFile();
      }
    });
  }

  openNewDocumentModal(): void {
    const dialogRef = this.dialog.open(GeneraldocumentUpdateComponent, {
      width: '600px',
      disableClose: true,
      autoFocus: true,
      data: { isEdit: false }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Modal kapandıktan sonra listeyi yenile
        this.loadFile();
      }
    });
  }

  openEditDocumentModal(node: FileNode): void {
    const dialogRef = this.dialog.open(GeneraldocumentUpdateComponent, {
      width: '600px',
      disableClose: true,
      autoFocus: true,
      data: {
        id: node.id,
        fileName: node.fileName,
        description: node.type === 'folder' ? '' : node.fileDescription,
        documentType: node.type,
        parentFolder: node.parent,
        filePath: node.filePath,
        orderSeq:node.orderSeq,
        isEdit: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Modal kapandıktan sonra listeyi yenile
        this.loadFile();
      }
    });
  }
}

